import { fetchModalPosCon, fetchPosCon } from './../api';
import { resetStateBuilder } from './helperReducers';
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isLoaded: false,
    loading: false,
    obj_datas: {
        data_ini: '',
        data_fim: '',
        data_ini2: '',
        datas_nao_uteis: '',
        data_mais_antiga_portfolio_AAAAmmDD: '',
        data_mais_recente_portfolio_AAAAmmDD: '',
    },
    loadingModal: false,
    datas_dados_ativos_agrupados: {},
    dados_ativos_agrupados: [],
    retornos_ativos: [],
    dadosModal: [],
};
export const posConSlice = createSlice({
    name: 'posCon',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        resetStateBuilder(builder, initialState);
        builder.addCase(fetchPosCon.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchPosCon.fulfilled, (state, action) => {
            var _a, _b, _c, _d;
            state.loading = false;
            state.isLoaded = true;
            state.obj_datas = (_a = action.payload.PosCon) === null || _a === void 0 ? void 0 : _a.obj_datas;
            state.dados_ativos_agrupados = (_b = action.payload.PosCon) === null || _b === void 0 ? void 0 : _b.dados_ativos_agrupados;
            state.datas_dados_ativos_agrupados = (_c = action.payload.PosCon) === null || _c === void 0 ? void 0 : _c.datas_dados_ativos_agrupados;
            state.retornos_ativos = (_d = action.payload.PosCon) === null || _d === void 0 ? void 0 : _d.retornos_ativos;
        });
        builder.addCase(fetchPosCon.rejected, (state) => {
            state.loading = false;
        });
        builder.addCase(fetchModalPosCon.pending, (state) => {
            state.loadingModal = true;
        });
        builder.addCase(fetchModalPosCon.fulfilled, (state, action) => {
            var _a, _b;
            state.loadingModal = false;
            state.dadosModal = (_b = (_a = action.payload.modais) === null || _a === void 0 ? void 0 : _a.PosCon[0]) !== null && _b !== void 0 ? _b : [];
        });
        builder.addCase(fetchModalPosCon.rejected, (state) => {
            state.loadingModal = false;
        });
    },
});
export default posConSlice.reducer;
